var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M29.9741 47.4433L23.1747 43.6315L29.8024 25.2594L29.9741 47.4433Z",
    stroke: "#506AC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M47.8761 4.51385L48.6662 4.80254L45.7033 6.51948L47.8761 4.51385Z",
    stroke: "#506AC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M47.4385 1.68266L32.2607 16.285V1.2151L47.4385 1.68266Z",
    stroke: "#506AC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M29.9407 17.7999H15.9262L29.9407 3.07037V17.7999Z",
    stroke: "#506AC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M3.46009 9.63967H1.2933L3.46009 7.66986V9.63967Z",
    stroke: "#506AC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M13.0841 17.9724C12.9357 18.1396 12.8353 18.2641 12.8003 18.3291V17.8799C12.8513 17.8799 12.9434 17.8883 13.0414 17.9448C13.0563 17.9534 13.0705 17.9626 13.0841 17.9724ZM12.7217 17.6275C12.6411 17.718 12.5672 17.8039 12.5067 17.8799H5.78013V6.2796H8.41669L15.788 14.5159C15.1585 15.1303 14.3637 15.9161 13.704 16.5901C13.3115 16.9912 12.9613 17.3582 12.7217 17.6275Z",
    stroke: "#506AC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M29.3732 20.0799L23.3225 37.162L7.19961 20.0799H29.3732Z",
    stroke: "#506AC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b9acc6ce30c4cc6dc8d970c0edb84544.svg";
export { ForwardRef as ReactComponent };